import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IApp03Portfolio } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';
import { App03Frameworks } from '../types/App03Workflow';

export class App03PortfolioService extends EntityWithStatusService<IApp03Portfolio> {
    //protected childrenEntities = ['Contributors($expand=ContributorUser)', 'CustomFields($expand=CustomFieldDfn)'];
    protected childrenEntities = ['App03PortfolioUsers($expand=User)', 'CustomFields($expand=CustomFieldDfn)'];

    constructor() {
        super(`/App03Portfolios`);
    }

    public readAllForList(includeClosed?: boolean, frameworkID?: App03Frameworks): Promise<IApp03Portfolio[]> {
        return this.readAll(
            `?$select=ID,Title,PortfolioTypeID`
            + `&$orderby=Title`
            + `&$expand=`
            //+ `App03Workflows($select=ID;$expand=App03WorkflowUsers($select=ID,UserID),App03Tasks($filter=Archived ne true;$select=ID,TaskPriorityID;$expand=App03TaskUsers($select=ID,UserID))),`
            + `App03PortfolioUsers($select=ID;$expand=User($select=Title))`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and FrameworkID eq ${frameworkID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public readAllForLookup(includeClosedEntities?: boolean, additionalFields?: string): Promise<IApp03Portfolio[]> {
        return this.readAll(
            `?$select=ID,Title,FrameworkID${additionalFields ? `,${additionalFields}` : ''}`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosedEntities ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public async readTitleForPortfolio(entityPlural: string, entitySingular: string, portfolioID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            DescriptionLine1: '',
            DescriptionLine2: '',
            Description1ForList: '',            
            Description1ForForm: ''
        };
        const res = await this.readAll(`?$filter=ID eq ${portfolioID}&$select=Title`);
        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for portfolio`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for portfolio <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for portfolio <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public countAllForList(frameworkID: App03Frameworks): Promise<IApp03Portfolio[]> {
        return this.readAll(
            `?$select=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and FrameworkID eq ${frameworkID} and EntityStatusID eq ${EntityStatus.Open}`
        );
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        return this.entityChildrenSingle(id, 'Workstreams', 'App03Workflows', true);
    }
    
    // public async create(workflow: IApp03Workflow): Promise<IApp03Workflow> {
    //     workflow.CustomerID = AppGlobals.CustomerID;           
    //     return super.create(workflow);
    // }

    // public async readTitlesForWorkflowUsers(workflowID: number): Promise<IEntityDescription1> {
    //     const entityDescription1: IEntityDescription1 = {
    //         Description1ForList: '',
    //         Description1ForForm: ''
    //     };
    //     const res = await this.readAll(`?$filter=ID eq ${workflowID}&$select=Title`);
    //     if (res.length > 0) {
    //         entityDescription1.Description1ForList = `Users with access to Workflow ${res[0].Title}`;
    //         entityDescription1.Description1ForForm = `Users with access to Workflow ${res[0].Title}`;
    //     }

    //     return entityDescription1;
    // }

    // public async readForView(workflowID: number): Promise<IApp03Workflow> {
    //     return this.read(
    //         workflowID,
    //         false,
    //         false,
    //         [
    //             'App03WorkflowUsers($expand=User($select=Title,EmailAddress))',
    //             'App03WorkflowStages($select=ID,Title)',
    //         ]
    //     );
    // }
}